import React, { useState } from 'react';
import { useNavigate,Link } from 'react-router-dom';

import axios from 'axios';
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
import SideNavbar from './helpers/SideNavbar';


const AddUser = () => {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();
  const navigate = useNavigate();
  const [role, setRole] = useState('1'); // Default role is HR
  const [isLoading, setIsLoading] = useState(false);
  const ClientID = localStorage.getItem("ClientID")
console.log("16",ClientID)
  const onSubmit = (data) => {
    setIsLoading(true);
    
    const payload = {
        RoleID:role,
        ClientID:ClientID,
        isActive:1,
        UserName: data.username,
        Email: data.email,
        Password: data.password,
        confirmPassword: data.confirmPassword,
    };
    console.log(payload)

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/adduseroradmin`, payload)
      .then(response => {
        //navigate("/Dashboard")
        setIsLoading(false);
        if (response.data.message === 'Email is already registered') {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Email is already registered',
            showConfirmButton: false,
            timer: 3000
          });
        } else if (response.data.message === 'User registered successfully!') {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'created successfully!',
            showConfirmButton: false,
            timer: 3000
          });
          navigate("/userslist")
        }
          else  if (response.data.message === 'Can not Add') {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'You have already created 20 users',
              showConfirmButton: false,
              timer: 3000
            });
        }
      })
      .catch(error => {
        setIsLoading(false);
        console.error('Error logging in:', error);
      });
  };

  return (
    <>
<SideNavbar>
<div className="card shadow-sm p-3" style={{ border: 'none', backgroundColor: '#fff' }}>
<div className="card-header d-flex justify-content-between" style={{ border: 'none', backgroundColor: '#fff' }}>
          <div className=''>
          <Link to= "/userslist">
                    <h5 className="welcome-text mt-4" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}><i class="fa fa-arrow-left" style={{marginRight:'30px'}}aria-hidden="true"></i>Add User</h5>
                      </Link>
                                </div>
          <div>
      
          </div>
        </div>
        <hr />
        <div className="container mt-2">
      <section className="vh-100">
        {isLoading ? <div className="spinner"></div> :
          <>
  <div className="row d-flex justify-content-center align-items-center mt-4">
    {/* <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
      <img
        src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
        className="img-fluid"
        alt="Sample" />
    </div> */}
    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
      <div className="card shadow-lg p-5" style={{ border: 'none' }}>
        <form onSubmit={handleSubmit(onSubmit)}>
            <label className="form-label text-center">Role</label>
          <div className="d-flex flex-direction-row justify-content-center align-items-center form-outline mb-4">
            <div className="radio-container"  style={{marginRight:30}}>
              <input
                type="radio"
                id="hrRole"
                name="role"
                value="0001"
                checked={role === '1'}
                onChange={() => setRole('1')} />
              <p htmlFor="hrRole">Personal Branding</p>
            </div>
            <div className="radio-container"  style={{marginRight:30}}>
              <input
                type="radio"
                id="hrRole"
                name="role"
                value="0004"
                checked={role === '4'}
                onChange={() => setRole('4')} />
              <p htmlFor="hrRole">Business Branding</p>
            </div>
         

          </div> 
          <div className="form-outline mb-4">
            <label className="form-label" htmlFor="form3Example3">
             Username
            </label>
            
            <input
              type="text"
              id="form3Example3"
              className={`form-control form-control-lg ${errors.username ? 'is-invalid' : ''}`}
              placeholder="Username"
              {...register('username', { 
                required: 'username is required',
              })}
            />
            {errors.username && <div className="invalid-feedback">{errors.username.message}</div>}
          </div>
          <div className="form-outline mb-4">
            <label className="form-label" htmlFor="form3Example3">
              Email address
            </label>
            <input
              type="email"
              id="form3Example3"
              className={`form-control form-control-lg ${errors.email ? 'is-invalid' : ''}`}
              placeholder="Enter a valid email address"
              {...register('email', { 
                required: 'Email is required', 
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: 'Invalid email address'
                }
              })}
            />
            {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
          </div>

          <div className="form-outline mb-3">
            <label className="form-label" htmlFor="form3Example4">
              Password
            </label>
            <input
              type="password"
              id="form3Example4"
              className={`form-control form-control-lg ${errors.password ? 'is-invalid' : ''}`}
              placeholder="Enter password"
              {...register('password', { 
                required: 'Password is required',
              })}
            />
            {errors.password && <div className="invalid-feedback">{errors.password.message}</div>}
          </div>
          <div className="form-outline mb-3">
            <label className="form-label" htmlFor="form3Example4">
            Confirm Password
            </label>
            <input
              type="password"
              id="form3Example5"
              className={`form-control form-control-lg ${errors.confirmPassword ? 'is-invalid' : ''}`}
              placeholder="Enter Confirm Password"
              {...register('confirmPassword', { 
                required: 'Confirm Password is required',
              })}
            />
            {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword.message}</div>}
          </div>

          {/* <div className="text-center text-lg-start mt-4 pt-2">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isSubmitting}
              style={{ backgroundColor: '#2e3192' }}
            >
              Register
            </button>
          </div> */}
          <div className="text-center  d-flex justify-content-between text-lg-start mt-4 pt-2">
           
           <button
             type="submit"
             className="btn btn-primary"
             disabled={isSubmitting}
             style={{ backgroundColor: '#2e3192',borderRadius:8 }}
           >
             Submit
           </button>
        
         </div>
        </form>
      </div>
    </div>
  </div>


          </>
        }
      </section>
      </div>
      </div>

      </SideNavbar>
    </>
  );
};

export default AddUser;
